import { sha256 } from 'js-sha256';
import store from '@/store';
import qs from 'qs';
import { isWeChatBrowser } from '@/utils/is';

let keyInfo = {};
if (process.env.VUE_APP_ENV === 'prod') {
  keyInfo = {
    appKey: '2505238142',
    secretKey: '996ec977d36e289552201498a53f3169',
  };
}
else {
  keyInfo = {
    appKey: '2505238142',
    secretKey: '996ec977d36e289552201498a53f3169',
  };
}

export const headers = (res) => {
  const { url } = res;
  const timestamp = new Date().getTime();
  const uuid_check = sha256(timestamp + url);
  const sign = getSign({ ...res, timestamp, uuid_check });

  const {
    token,
    modelId,
  } = store.getters.userInfo;
  const Authorization = url.includes('/beijing-auth-iam-customer/oauth/token') ? `Basic MjAwMDA0Omg1QDIwMjI=` : token ? `Bearer ${token}` : '';
  console.log('strictUriEncode===>', strictUriEncode(sign));
  const headerParams = {
    // userId: window.uid || '',
    Authorization,
    modelId: modelId || 5,
    'device-type': isWeChatBrowser() ? 'APPLET-H5' : 'H5',
    'ice-auth-appkey': keyInfo.appKey,
    'ice-auth-timestamp': timestamp,
    'ice-auth-sign': sha256(strictUriEncode(sign)), // 加密前进行URL编码
    'ice-auth-uuid': uuid_check,
  };
  return headerParams;
};

// 整合加密前数据
const getSign = (res) => {
  const { url, params, data = {}, timestamp, headers = {}, uuid_check } = res;
  let { method } = res;
  let qs_data = method === 'post' ? data : params;
  const paramsSort = {};
  let sign = '';
  if (method === 'post' && headers['Content-Type']?.includes('x-www-form-urlencoded')) {
    // post表单
    method = 'POSTFORM';
    qs_data = qs.parse(data);
  }
  const sort = method === 'post' ? Object.keys(qs_data) : Object.keys(qs_data).sort();
  sort.forEach(key => {
    if (method === 'get' && qs_data[key] === undefined) {
      return;
    }
    /**
     * get参数key需要转小写
     * post参数值为空设置为null，get不处理参数值
     */
    const val = qs_data[key] ?? null;
    paramsSort[method === 'post' ? key : key.toLowerCase()] = method === 'post' ? val : qs_data[key];
  });
  if (method === 'post') {
    sign = `POST${url}ice-auth-appkey:${keyInfo.appKey}ice-auth-timestamp:${timestamp}ice-auth-uuid:${uuid_check}json=${JSON.stringify(paramsSort)}${keyInfo.secretKey}`;
  }
  else if (method === 'get') {
    sign = `GET${url}ice-auth-appkey:${keyInfo.appKey}ice-auth-timestamp:${timestamp}ice-auth-uuid:${uuid_check}${formdataify(paramsSort)}${keyInfo.secretKey}`;
  }
  else {
    // post使用form提交，采用git方式生成签名
    sign = `POST${url}ice-auth-appkey:${keyInfo.appKey}ice-auth-timestamp:${timestamp}ice-auth-uuid:${uuid_check}${formdataify(paramsSort)}${keyInfo.secretKey}`;
  }
  console.log('sign===>', sign);
  return sign;
};

// 处理get参数，json转字符串
const formdataify = (params) => {
  const formData = [];
  Object.keys(params).forEach(key => {
    if (params[key] instanceof Array) {
      params[key].forEach((item) => {
        formData.push(`${key}=${item}`);
      });
      return;
    }
    formData.push(`${key}=${params[key]}`);
  });
  return formData.join('');
};

/**
 * 严格按照 RFC 3986来编码字符串
 * @param str
 */
const strictUriEncode = (str) => {
  return (
    encodeURIComponent(str)
      .replace(/[!'()~]/g, (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`)
      // 参数中携带的空格去掉
      .replaceAll('%20', '') // 适配java的空格转成+
  );
};
